/* eslint-disable no-undef */
import React, { useContext, useEffect, useState } from 'react';
import { useSelector, connect } from 'react-redux';

import { getInputIndex, actionError } from 'helpers/actionHelpers';
import LocaleContext from 'constants/localization';
import API from 'constants/api';

import Header from 'field/common/Header';
import CreateResourceButton from 'field/edit/resource/CreateResourceButton';
import EditLinkedResources from 'field/edit/resource/EditLinkedResources';

// SPEC-86, add Objects from Acquisition
const AcquisitionObjectEdit = (props) => {
  const { field, actionError } = props;
  const museum = useSelector(state => state.object.museum);
  const uri = useSelector(state => state.object.uri);
  const LS = useContext(LocaleContext);
  const [view, setView] = useState(null);

  useEffect(() => {
    fetch(`${API.ACQUISITION}/acquisitionTargetType?uri=${encodeURIComponent(uri)}`)
      .then(res => res.json())
      .then(json => {
        if (json.view) {
          setView(json.view);
        } else {
          actionError(new Error('noAcquisitionTargetType'));
        }
      });
  }, []);

  const openCreate = () => {
    const params = encodeURIComponent(`addContent.do?museum=${museum}&view=${view}&acquisition=${uri}`);
    window.open(`index.do?main_action=${params}`, '_blank');
  };

  const openEdit = e => {
    const index = getInputIndex(e);
    const uri = field.values[index].uri;
    window.open(`index.do?main_action=editObject.do?uri=${uri}`, '_blank');
  };

  return (
    <div className="field">
      <Header field={field} />
      <CreateResourceButton
        onCreate={openCreate}
        label={LS.target}
        disabled={view === null}
        style={{ marginBottom: '1rem' }} />
      <EditLinkedResources
        onEdit={openEdit}
        values={field.values} />
    </div>
  );
};

export default AcquisitionObjectEdit;